import React from 'react';
import { useParams } from 'react-router-dom';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const { invoiceId } = useParams(); // Get invoiceId from URL parameters

  return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        <h1 className="payment-success-title">Payment Successful!</h1>
        <p className="payment-success-message">
          Congratulations! Your payment {invoiceId ? `with Invoice ID: ${invoiceId}` : ''} has been processed successfully.
        </p>
        <p className="payment-success-instructions">
          Please check your email for further instructions and next steps, including how to book your exam appointment.
        </p>
        <a href="/" className="payment-success-button">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default PaymentSuccess;